import { scaleBand, scaleLinear } from 'd3-scale';
import displayTextWidth from '@/utils/textCalcs';

export default {
  computed: {
    paddingOuterPx() {
      return this.h_yScale.bandwidth() * (this.paddingInner / 2);
    },
    h_scaleBandDomain() {
      return [...Array(this.domainY.length).keys()];
    },
    h_yScale() {
      return scaleBand()
        .domain(this.h_scaleBandDomain)
        .range(this.rangeY)
        .paddingInner(this.paddingInner)
        .paddingOuter(this.paddingInner / 2);
    },
    h_xScale() {
      return scaleLinear()
        .domain(this.bandX ?? this.domainX)
        .range(this.rangeX);
    },
  },
  methods: {
    getOffsetWidth(d) {
      if (this.offsetX === 0) {
        return 0;
      }

      let finalOffset = this.offsetX;

      if (d[0] === 0) {
        finalOffset = this.domainX[0] >= 0 ? 0 : this.offsetX / 2;
      }

      if (d[1] === 0) {
        finalOffset = this.domainX[1] < 0 ? 0 : this.offsetX / 2;
      }

      return finalOffset;
    },
    getOffsetX(d) {
      if (this.offsetX === 0 || d[1] <= 0) {
        return 0;
      }

      let finalOffset = this.offsetX;

      if (d[0] === 0) {
        finalOffset = this.domainX[0] >= 0 ? 0 : this.offsetX / 2;
      }

      return finalOffset;
    },
    getBarXPosition(d) {
      return Array.isArray(d)
        ? this.h_xScale(d[0]) + this.getOffsetX(d)
        : d < 0
        ? this.h_xScale(0) - this.getBarWidth(d)
        : this.h_xScale(0);
    },
    getBarWidth(d) {
      const width = Array.isArray(d)
        ? Math.abs(this.h_xScale(d[1]) - this.h_xScale(d[0])) - this.getOffsetWidth(d)
        : Math.abs(this.h_xScale(d) - this.h_xScale(0));

      return width;
    },
    getValueWidth(d) {
      return displayTextWidth(
        d,
        '14pt MorningstarIntrinsic, HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif'
      );
    },
  },
};
